import { render, staticRenderFns } from "./singleSugestion.vue?vue&type=template&id=4e7852fa&scoped=true&lang=html&"
import script from "./singleSugestion.vue?vue&type=script&lang=js&"
export * from "./singleSugestion.vue?vue&type=script&lang=js&"
import style0 from "./singleSugestion.vue?vue&type=style&index=0&id=4e7852fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7852fa",
  null
  
)

export default component.exports